import clients from '../../data/clients';

import DreamWorks from '../work/dreamworks';
import HpWearable from '../work/hp-wearable';
import LandRover from '../work/land-rover';
import VirtualLessonPlan from '../work/virtual-lesson-plan';

export default {
  layout: 'default',
  blocks: [
    {
      module: 'hero',
      stretch: true,
      ornament: true,
      overlay: true,
      headline: "We are a product design agency for global brands.",
      background: {
        type: 'video',
        src: require('@/content/homepage/images/hero-video-720p.mp4'),
        poster: require('@/content/homepage/images/hero-video-poster.jpg'),
      },
    },
    {
      module: 'featuredItems',
      id: 'homepageFeaturedWork',
      title: 'Our Work.',
      byline: null,
      itemType: 'work',
      items: [
        LandRover.slug,
        DreamWorks.slug,
        HpWearable.slug,
        VirtualLessonPlan.slug,
      ],
      // outlink: {
      //   copy: "View more work",
      //   href: "/work",
      // },
    },
    {
      module: 'row',
      singleton: true,
      columns: [
        {
          grid: {
            start: 1,
            end: 5,
          },
          component: 'bigHeading',
          heading: 'Our method is our difference.',
        },
        {
          grid: {
            start: 7,
            end: 12,
          },
          component: 'contentStack',
          stack: [
            {
              type: 'markdown',
              content: 'Particle Design is a user experience design agency for future-forward brands. We work with our clients to design experiences that solve complex problems.',
              href: {
                name: 'L2',
                params: {
                  slug: 'about',
                },
              },
            },
            {
              type: 'linkWithButtonBelow',
              text: 'Read more about Particle',
              href: {
                name: 'L2',
                params: {
                  slug: 'about',
                },
              },
            },
          ],
        },
      ],
    },
    {
      module: 'row',
      singleton: true,
      styles: {
        gridGap: 0,
      },
      id: 'homepage__image-row',
      columns: [
        {
          grid: {
            start: 1,
            end: 3,
          },
          component: 'image',
          src: require('./images/crystal.png'),
          alt: 'geometric representation of a polyhedron with triangle faces',
        },
        {
          grid: {
            start: 4,
            end: 6,
          },
          component: 'image',
          src: require('./images/lightbulb.png'),
          alt: 'geometric representation of a polyhedron with triangle faces',
        },
        {
          grid: {
            start: 7,
            end: 9,
          },
          component: 'image',
          src: require('./images/stack.png'),
          alt: 'geometric representation of a polyhedron with triangle faces',
        },
        {
          grid: {
            start: 10,
            end: 12,
          },
          component: 'image',
          src: require('./images/thumb.png'),
          alt: 'geometric representation of a polyhedron with triangle faces',
        },
      ],
    },
    {
      module: 'partners',
      clients: [clients.dreamworks, clients.vh1, clients.hp, clients.moovel, clients.jaguar, clients.landrover, clients.samsung, clients.regence, clients.outcome, clients.skyryse, clients.gm, clients.mentorSiemens],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/homepage/content.js